import React from 'react';
import { Button } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import { isFunction } from 'lodash';


const NextBestActionsRow = ({ data }) => {
    const { name, desc, image, color, action, component } = data;
    return (
        <div className="media media-list">
            <img title="" alt="" className={`zmdi zmdi-${image} text-${color} zmdi-hc-fw`} />
            <div className="media-body">
                <h3 className="mt-0">{name}</h3>
                <p className="card-text">{desc}</p>
                {component ?
                    component
                    :
                    (
                        <div className="my-2 btn-group-mins">
                            <Button size="lg" color="primary" className="btn jr-btn-sm btn-primary" onClick={(action && isFunction(action)) ? action : null}><i className="zmdi zmdi-comment-alert mr-1" /><IntlMessages id="options.action" /></Button>
                        </div>
                    )
                }
            </div>
        </div>
    );
};

export default NextBestActionsRow;



// WEBPACK FOOTER //
// ./components/Agile/Components/NextBestActionsRow.js